import { usePharmacySalesTrash } from './usePharmacySales';
import {
  usePharmacySupplierTrash,
  usePharmacyPurchaseOrderTrash,
  usePharmacyGoodsReceiptTrash,
} from './usePharmacyPurchasing';

/**
 * Combined number of items currently in the pharmacy trash
 * (sales + suppliers + purchase orders + goods receipts).
 *
 * Every trash list is queried with `limit: 1` so we only pay for the
 * `meta.total` count; the fetched rows themselves are discarded.
 * The query keys match the trash pages, so mutations that invalidate
 * `['pharmacy-sales-trash']`, `['pharmacy-supplier-trash']`, etc. also
 * refresh this counter automatically.
 */
export function usePharmacyTrashCount() {
  const sales = usePharmacySalesTrash(1, 1);
  const suppliers = usePharmacySupplierTrash(1, 1);
  const purchaseOrders = usePharmacyPurchaseOrderTrash(1, 1);
  const goodsReceipts = usePharmacyGoodsReceiptTrash(1, 1);

  const count =
    (sales.data?.meta?.total ?? 0) +
    (suppliers.data?.meta?.total ?? 0) +
    (purchaseOrders.data?.meta?.total ?? 0) +
    (goodsReceipts.data?.meta?.total ?? 0);

  return {
    count,
    isLoading:
      sales.isLoading ||
      suppliers.isLoading ||
      purchaseOrders.isLoading ||
      goodsReceipts.isLoading,
  };
}
